import { IBackgroundJobDto } from 'src/generated-types/backgroundJob'
import { useGet, usePost } from './reactQuery'

const adminBaseUrl = () => 'admin/background-jobs'

export const backgroundJobsEndpoints = {
  getAll: () => adminBaseUrl(),
  trigger: () => `${adminBaseUrl()}/trigger`,
}

export const useGetBackgroundJobs = () => useGet<IBackgroundJobDto[]>(backgroundJobsEndpoints.getAll())

export const useTriggerBackgroundJob = () => usePost<any, { id: string }>(backgroundJobsEndpoints.trigger())
